module.exports = __webpack_public_path__ + "static/media/biteship-popexpress.9cbcf911.png";